import { render, staticRenderFns } from "./PointsCompanyTab.vue?vue&type=template&id=b078a8dc"
import script from "./PointsCompanyTab.vue?vue&type=script&lang=js"
export * from "./PointsCompanyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports